import React from 'react';
import { Box, Typography, Chip } from '@mui/material';

const SectionTitle = ({ overline, title, subtitle, align = 'left' }) => {
  return (
    <Box sx={{ textAlign: align, mb: 4 }}>
      {overline && (
        <Chip
          label={overline}
          size="small"
          sx={{
            mb: 1.5,
            borderRadius: 999,
            backgroundColor: 'rgba(31,186,104,0.08)',
            color: 'primary.main',
            fontWeight: 600
          }}
        />
      )}
      <Typography variant="h3" sx={{ mb: 1 }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ maxWidth: 520, mx: align === 'center' ? 'auto' : 0 }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default SectionTitle;
